import React, {useContext} from 'react'

//Node Modules
import {NavDropdown, Nav, Dropdown} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

//Contexts
import { RequestorContext } from 'context/content-context'

//Components
import { ExportIcon } from 'components/SASIcon'

//Styles
import styles from './VersionPicker.module.scss'
import itemStyles from './Item.module.scss'

//Hooks
import { useIsSmallDevice } from 'hooks'

interface Props {
  label: string
  menu: React.ReactNode
  variant?: "dark" | "light" 
  allUrl? : string
}

const VersionPicker = ({label, menu, variant="light", allUrl}:Props) => {
  const requestorId = useContext(RequestorContext)
  const isSmallDevice = useIsSmallDevice()
  const { t } = useTranslation()
  const allVersionsItem = () => {
    return (<a href={`${allUrl}${requestorId ? '&requestorId='+requestorId : ''}`} rel="noopener noreferrer" target='_blank' className={`${itemStyles.item} dropdown-item ${itemStyles.allVersions}`} onKeyDown={handleKeyboard} >{t('helpcenter-gui-icu.mainnav.version.menu.all_version.label')}<ExportIcon /></a>)
  }

  const handleKeyboard = (e: React.KeyboardEvent) => {
    if (e.keyCode === 32) {
      let target = e.currentTarget as HTMLElement 
      target.click()
    }
  }

  return (
    <>
      <NavDropdown 
        id="content-version-picker" 
        as={Nav.Item}
        className={`${styles.versionPicker} ${variant}`}
        title={label}
        onToggle={(isOpen:boolean) => {
          if (!isOpen) {
            window.dispatchEvent(new CustomEvent('version-picker-close'))
          }
        }}
      >
      <div className={`${styles.menu} ${isSmallDevice ? styles.smallDevice : ''}`} role="application" id="Version-Picker-Menu">
        { menu }
        {allUrl ? <><div className='divider'/><Dropdown.Item as={allVersionsItem} ></Dropdown.Item></> : null}
      </div>
        
      </NavDropdown>
    </>
  )
}

export default VersionPicker